/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-12 18:13:57
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-26 10:23:14
 */
import { AnyAction } from "redux";
import produce from "immer";

const campaign = {
	sourceIsSmartCreative: false,
	sourceCampaignInfo: {
		campaignName: ""
	},
	sourceCampaignAdgroupInfo: {
		campaignNameList: []
	},
	sourceAccount: {},
	targetAccount: {},
	copyCount: 1,

	isEveryDayCopy: false,
	copyDay: 0,
	everyDayCopyCount: 0,

	campaignNameList: [],

	campaignFormInfo: {},

	/** 存Smart的表单信息 */
	SmartADText: [],

	/** 存素材信息 */
	materialList: [
		{
			isEmpty: true,
			index: 0
		}
	],
	/** 存Smart素材信息 */
	smartMaterialList: [],
	smartAdAttribute: {},
	curOperationMaterial: {
		isEmpty: true,
		index: 0
	},
	identity: {}
};

// auth reducer
const COPYCAMPAIGN = (state = campaign, action: AnyAction) =>
	produce(state, draftState => {
		switch (action.type) {
			case "SET_COPY_COUNT":
				draftState.copyCount = action.count;
				break;
			case "SET_SOURCE_ADVERTISER":
				console.log("actionaction?>>>>>>>>>", action);
				draftState.sourceAccount = action.sAdAccount;
			case "SET_TARGET_ADVERTISER":
				draftState.targetAccount = action.adAccount;
				break;
			case "SET_IS_EVERYDAY_COPY":
				console.log("actionaction", action);
				draftState.isEveryDayCopy = action.isEveryDay;
				break;
			case "SET_COPY_DAYS":
				draftState.copyDay = action.days;
				break;
			case "SET_EVERY_DAY_COPY_COUNT":
				draftState.everyDayCopyCount = action.count;
				break;
			case "SET_SOURCECAMPAIGN_IS_SMARTCREATIVE":
				draftState.sourceIsSmartCreative = action.creativeType;
				break;
			case "SET_SOURCECAMPAIGN_ADGROUP_INFO":
				draftState.sourceCampaignAdgroupInfo = action.adgroup;
				break;
			case "SET_SOURCECAMPAIGN_CAMPAIGN_INFO":
				draftState.sourceCampaignInfo = action.campaign;
				break;
			case "SET_CAMPAIG_NNAME_LIST":
				draftState.campaignNameList = action.campaignNameList;
				break;
			case "SET_CAMPAIGN_FORM_INFO":
				draftState.campaignFormInfo = action.campaign;
				break;
			case "SET_COPY_MATERIAL_LIST":
				draftState.materialList = action.ad;
				break;
			case "SET_COPY_SMART_MATERIAL_LIST":
				draftState.smartMaterialList = action.smartAd;
				break;
			case "SET_SMART_AD_TEXT":
				draftState.SmartADText = action.smartAdText;
				break;
			case "SET_SMART_AD_ATTRIBUTE":
				draftState.smartAdAttribute = action.smartAdAttribute;
				break;
			case "SET_CURRENT_OPERATION_MATERIAL":
				draftState.curOperationMaterial = action.material;
				break;
			default:
				return draftState;
		}
	});

export default COPYCAMPAIGN;
